
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/fabric",
      function () {
        return require("private-next-pages/sources/fabric.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/fabric"])
      });
    }
  